import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, InputGroupValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class InputGroupHandler implements IQueryConditionHandler {
  // qc.comparetypeåªæç­äºãç¸ä¼¼
  convert(qc: QueryCondition) {
    const igv = (qc.value as InputGroupValue);
    const arr = [];

    if (igv.isInputText || igv.textField == null) {
      arr.push({
        'FilterField': qc.fieldCode,
        'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Like,
        'Value': igv.textValue, // encodeURIComponent(igv.textValue),
        'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And,
        'Expresstype': ValueType.Value,
        'Lbracket': qc.Lbracket || null,
        'Rbracket': qc.Rbracket || null
      });
      return arr;
    } else {
      igv.getOriginalValue().split(',').forEach((itemValue) => {
        itemValue && arr.push({
          'FilterField': qc.fieldCode,
          'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
          'Value': itemValue,
          'Relation': qc.compareType === CompareType.NotEqual ? RelationType.And : RelationType.Or,
          'Expresstype': ValueType.Value
        });
      });
      if (arr.length > 0) {
        arr[0]['Lbracket'] = qc.Lbracket ? (qc.Lbracket + '(') :'(';
        arr[arr.length -1]['Rbracket'] = qc.Rbracket ? (qc.Rbracket + ')') : ')';
        arr[arr.length - 1]['Relation'] = (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And;
        return arr;
      } else {
        return [];
      }
    }
  }
}
